import React, { Fragment, useContext } from 'react'
import { withRouter, Redirect } from 'react-router-dom'
import { useQuery } from 'react-apollo'
import getAllDeals from 'graphql/getAllDeals'
import { HeroHeader } from 'components/hero-header'
import { Button } from 'components/button'
import { ContentBlock } from 'components/content-block'
import { Loader } from 'components/loader'
import { Text } from 'components/text'
import { Box } from 'components/box'
import { useTrackImpression } from 'utils/hooks/useTrackImpression'
import { useCurrentBreakpoint } from 'utils/hooks/useCurrentBreakpoint'
import { handleSessionError } from 'utils/error-tracking'
import { MessageFormat } from '@paypalcorp/worldready'
import {
  Message,
  Context as WorldReadyContext,
} from '@paypalcorp/worldready-react'

const media = {
  lg:
    'https://www.paypalobjects.com/digitalassets/c/gifts/us/stickers_d_02.mp4',
  sm:
    'https://www.paypalobjects.com/digitalassets/c/gifts/us/stickers_m_02.mp4',
}

const Deals = () => {
  const { data, loading, error } = useQuery(getAllDeals)
  const cbp = useCurrentBreakpoint()

  if (loading) return <Loader height="200px" />

  if (error) {
    handleSessionError(error)
    return <Redirect to="/error" />
  }

  const allDeals = data.getDealsInfo
  const noDeals = !allDeals

  if (noDeals)
    return (
      <Box display="flex" height="200px">
        <Text m="auto" textStyle="h4">
          {<Message id="pages/deals.deals.empty" />}
        </Text>
      </Box>
    )

  return allDeals.map((deal, i) => (
    <ContentBlock
      pt="x7"
      pb={i === allDeals.length - 1 ? `x7` : '0'}
      key={deal.name}
      header={deal.name}
      body={deal.description}
      terms={deal.terms}
      img={(cbp < 1 ? deal.mobile_banner_url : deal.banner_url) || deal.img_url}
      variant={i % 2 === 0 ? 'left' : 'right'}
      ctaComponent={
        <Button
          variant="primary"
          width="15rem"
          label={<Message id="pages/deals.deals.cta" />}
          href={deal.url_key}
          name="SeeDeal"
          data-pagename={`main:consumer:gifts:deals:`}
          data-pagename2={`main:consumer:gifts:deals:${deal.url_key}:::`}
        />
      }
    />
  ))
}

const DealsPage = () => {
  useTrackImpression(
    'main:consumer:gifts:deals:',
    'main:consumer:gifts:deals::::',
  )

  const worldready = useContext(WorldReadyContext)
  const suggestions = new MessageFormat(worldready, {
    id: 'pages/suggestions.suggestions.all',
  }).format()

  return (
    <Fragment>
      <HeroHeader
        headerStyle="search"
        headline={new MessageFormat(worldready, {
          id: 'pages/deals.deals.hero.title',
        }).format()}
        headlineSize="md"
        searchSuggestions={suggestions ? suggestions.split(',') : []}
        mediaSrc={media}
      />
      <Deals />
    </Fragment>
  )
}

export default withRouter(DealsPage)
